<template>
  <div class="ViewPageFacility">
    <HeroSecondary
      v-if="hero"
      :heading="hero.heading"
      :image="hero.image || null"
    />
    <div class="ViewPageFacility__container-1">
      <UnltdRepeatBG class="ViewPageFacility__bg-1"/>
      <UnltdRepeatBG class="ViewPageFacility__bg-2"/>
      <ProgramsMethod
        v-if="introduction"
        v-bind="introduction"
        class="ViewPageFacility__introduction"
      />
    </div>
    <div class="ViewPageFacility__container-2">
      <template v-if="galleries">
        <ProgramExperience
          v-for="(gallery, index) in galleries"
          v-bind="gallery"
          :key="index"
          class="ViewPageFacility__gallery"
        />
      </template>
    </div>
  </div>
</template>

<script>
  import HeroSecondary from './HeroSecondary';
  import UnltdRepeatBG from './UnltdRepeatBG';
  import ProgramsMethod from './ProgramsMethod';
  import ProgramExperience from './ProgramExperience';

  export default {
    components: {
      HeroSecondary,
      UnltdRepeatBG,
      ProgramsMethod,
      ProgramExperience,
    },
    props: {
      hero: {
        type: Object,
        default: null,
      },
      introduction: {
        type: Object,
        default: null,
      },
      galleries: {
        type: Array,
        default: null,
      },
    },
    cleanProps({
      acf: {
        hero,
        introduction,
        galleries,
      },
    }) {
      return {
        hero,
        introduction,
        galleries: galleries.map(({
          heading: name,
          images: elements,
          description,
        }) => ({
          name,
          elements: elements ? elements.map(({ ID: id }) => id) : [],
          description,
        })),
      };
    },
    // data() {
    //   return {
    //     hero: undefined,
    //   }
    // },
  };
</script>

<style lang="scss">
  .ViewPageFacility__container-1,
  .ViewPageFacility__container-2 {
    position: relative;
    max-width: $max-width;
    margin: spacing(base-zeta) auto;

    @include breakpoint(phablet) {
      margin-top: spacing(base-eta);
      margin-bottom: spacing(base-eta);
    }
  }

  .ViewPageFacility__container-1 {
    @include breakpoint(phablet) {
      padding-right: spacing(base-epsilon);
      padding-left: spacing(base-epsilon);
    }
  }

  .ViewPageFacility__introduction {
    @include breakpoint(tablet) {
      margin-right: spacing(base-delta) / -2;
      margin-left: spacing(base-delta) / -2;
    }
  }

  .ViewPageFacility__bg-1 {
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    height: 450px;
    fill: color(lightest-grey);
    transform: translateX(5%);

    @include breakpoint(phablet) {
      height: 600px;
      transform: translateX(50%);
    }
  }

  .ViewPageFacility__bg-2 {
    position: absolute;
    z-index: 0;
    top: 480px;
    right: 0;
    height: 450px;
    fill: color(lightest-grey);
    transform: translateX(5%);

    @include breakpoint(phablet) {
      top: 630px;
      height: 600px;
      transform: translateX(50%);
    }
  }

  .ViewPageFacility__gallery {
    & + & {
      margin-top: spacing(base-eta);
    }

    &:nth-child(even) .ProgramExperience__main {
      flex-direction: row-reverse;
    }
  }

  .ViewPageFacility {
    .ProgramExperience__heading span,
    .ProgramElements__image-label > span:last-child,
    .ProgramsMethod__logo {
      display: none;
    }
  }
</style>
